import { handleActions, combineActions } from 'redux-actions';
import {  Map,fromJS } from 'immutable';

import actions from '@synergycms_app/store/actions';
import applicationDefaults from '../../../config/defaults';


//REDUCERS
const {
  app: appActions
} = actions;

const app = handleActions(
  {
    [appActions.name.get.toString()]: (app, { payload }) => {
      return app.set("name", payload);
    },
    [appActions.loaded.get.toString()]: (app, { payload }) => {
      return app.set("loaded", payload);
    },
    [appActions.outerWeb.get.toString()]: (app, { payload }) => {
      return app.set('outer_web', payload);
    },
    [combineActions(
      appActions.config.get.toString(),
      appActions.config.getAsync.toString(),
      appActions.config.getHotel.toString(),
      appActions.config.getHotelAsync.toString()
    )]: (app, {payload: { hotelId, config }}) => {
      const appName = app.get('name', 'avail');
      if (hotelId && config) {
        const hotelConfig = {[hotelId] : config};
        const defaultHotelConfig = fromJS(applicationDefaults[appName]).merge(app.get('hotelConfig', Map()));
        return app.set('hotelConfig', defaultHotelConfig.merge(fromJS(hotelConfig)));
      } else if (config) {
        return app.set('config', fromJS({...applicationDefaults[appName], ...config}));
      }
    }
  },
  Map()
);

export default app;
